// @ts-nocheck
import React from 'react';
import useApiRequest from './useRequest';

const logPdfRequestError = async (error) => {
  const status = error?.response?.status;
  const requestUrl = error?.config?.url;
  let payload = error?.response?.data;

  if (payload instanceof Blob) {
    const text = await payload.text();

    try {
      payload = JSON.parse(text);
    } catch {
      payload = text;
    }
  }

  console.error('PDF request failed', {
    status,
    url: requestUrl,
    payload,
    error,
  });
};

export const useRequestPdf = (httpProps = {}) => {
  const apiRequest = useApiRequest();
  const [isLoading, setIsLoading] = React.useState(false);
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [pdfUrl, setPdfUrl] = React.useState('');
  const [response, setResponse] = React.useState(null);

  const { enabled = true, url, ...requestProps } = httpProps || {};

  React.useEffect(() => {
    if (!enabled || !url) {
      return;
    }

    setIsLoading(true);
    apiRequest
      .http({
        headers: { accept: 'application/pdf' },
        responseType: 'blob',
        ...requestProps,
        url: `/api/${url}`,
      })
      .then((response) => {
        // Create a Blob from the PDF Stream.
        const file = new Blob([response.data], { type: 'application/pdf' });

        // Build a URL from the file
        const fileURL = URL.createObjectURL(file);

        setPdfUrl(fileURL);
        setIsLoading(false);
        setIsLoaded(true);
        setResponse(response);
      })
      .catch(async (error) => {
        setIsLoading(false);
        setIsLoaded(false);
        setResponse(error?.response ?? null);

        await logPdfRequestError(error);
      });
  }, [enabled, url]);

  return {
    isLoading,
    isLoaded,
    pdfUrl,
    response,
  };
};